import { segmentTrackMaxTotalCostsDropdownChange } from "analytics/analyticTrackEvents";
import useMapViewConfiguration from "contexts/MapViewConfigurationContext/hooks/useMapViewConfiguration";
import { useMapViewRoutingMetadata } from "contexts/RoutingMetadataContext";
import { MaybeMaxCosts } from "types/busFilterTypes";
import CostsInput from "./CostsInput";
import FilterWrapper from "./FilterWrapper";

const TotalCostFilter: React.FC = () => {
    const {
        busFiltersConfiguration: {
            busFilters: { maybeMaxTotalCosts },
            updateMaybeMaxTotalCosts
        }
    } = useMapViewConfiguration();
    const { componentConfig } = useMapViewRoutingMetadata();

    // PIL regions (SPP CPP) always apply a total cost cap, so the on/off toggle
    // is removed and the filter is locked on.
    const lockedOn =
        componentConfig.hasPlannedInterconnectionLocations === true;

    return (
        <FilterWrapper label={"Total cost (millions)"}>
            <CostsInput
                maxCost={maybeMaxTotalCosts}
                lockedOn={lockedOn}
                setMaxCost={(newMaybeMaxTotalCosts: MaybeMaxCosts) => {
                    updateMaybeMaxTotalCosts(newMaybeMaxTotalCosts);
                    segmentTrackMaxTotalCostsDropdownChange(
                        newMaybeMaxTotalCosts,
                        maybeMaxTotalCosts
                    );
                }}
            />
        </FilterWrapper>
    );
};

export default TotalCostFilter;
